import React, { ComponentProps, forwardRef } from 'react';
import { Accordion as MuiAccordion } from '@mui/material';

type Props = ComponentProps<typeof MuiAccordion> & {
  fullWidth?: boolean;
};

/**
 * !IMPORTANT: MUI developers forgot to add generic for the component/ref that why we can't
 * use component="a/section ...." in typescript without // @ts-expect-error MUI generic types issue
 *
 * example:

  const sectionRef = useRef<HTMLElement>(null);

  <Accordion
    component="section"
    // @ts-expect-error MUI generic types issue
    ref={sectionRef}
  >
  ...
</Accordion>

 */
const Accordion = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { fullWidth, sx, ...rest } = props;

  return (
    <MuiAccordion
      ref={ref}
      {...rest}
      sx={{
        ...(fullWidth && { width: '100%' }),
        ...sx,
      }}
    />
  );
});

export default Accordion;
